import { useContext } from 'react';
import GlobalsContext from '../contexts/GlobalsContext';
import type { GlobalsContextValue } from '../contexts/GlobalsContext';

const useGlobals = (): GlobalsContextValue => useContext(GlobalsContext);

export default useGlobals;
